<template>
    <div
            class="modal fade"
            id="show_sys_detai"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" data-dismiss="modal" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">基站详情</h4>
                </div>
                <div class="modal-body">
                    <form id="sys_dlg_form" role="form" class="form-horizontal">
                        <div>
                            <ul class="nav nav-tabs">
                                <li class="active">
                                    <a data-toggle="tab" href="#tab-1">基站基础信息</a>
                                </li>
                                <li class>
                                    <a data-toggle="tab" href="#tab-2">基站地理位置信息</a>
                                </li>
                                <li class>
                                    <a data-toggle="tab" href="#tab-3">运营商信息</a>
                                </li>
                                <li class>
                                    <a data-toggle="tab" href="#tab-4">代维、待谈公司信息</a>
                                </li>
                                <li class>
                                    <a data-toggle="tab" href="#tab-5">业主信息</a>
                                </li>
                                <li class>
                                    <a data-toggle="tab" href="#tab-6">供电信息</a>
                                </li>
                            </ul>
                            <div class="tab-content">
                                <div id="tab-1" class="tab-pane active">
                                    <div class="panel-body">
                                        <div class="form-group">
                                            <label class="col-sm-2 control-label">JT号：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_jtno"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_jtno"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                            <label class="col-sm-2 control-label">基站二维码：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_ercode"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_ercode"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 control-label">基站名称：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_commname"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_commname"
                                                        class="form-control"
                                                />
                                            </div>
                                            <label class="col-sm-2 control-label">基站状态：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_status"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_status"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 control-label">备注：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_remarks"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_remarks"
                                                        class="form-control"
                                                />
                                            </div>
                                            <label class="col-sm-2 control-label">基站照片：</label>
                                            <div class="col-sm-4">
                                                <img
                                                        style="width:200px;margin-bottom:8px;"
                                                        v-if="ammeterInfo.stst_stationpicture"
                                                        :src="ammeterInfo.stationpicture"
                                                />
                                                <span v-else>暂无照片</span>
                                                <input
                                                        type="file"
                                                        id="stationpicture"
                                                        placeholder="选择基站照片"
                                                        class="form-control file-pretty_station"
                                                        @change="changeImg('stationpicture')"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="tab-2" class="tab-pane">
                                    <div class="panel-body">
                                        <div class="form-group">
                                            <label class="col-sm-2 control-label">基站位置：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_address"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_address"
                                                        class="form-control"
                                                />
                                            </div>
                                            <label class="col-sm-2 control-label">基站形式：</label>
                                            <div class="col-sm-4">
                                                <select
                                                        name="stst_type"
                                                        class="chosen-select"
                                                        v-model="ammeterInfo.stst_type"
                                                >
                                                    <option value>&nbsp;</option>
                                                    <option value="楼站">楼站</option>
                                                    <option value="塔站">塔站</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 control-label">经度：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_longitude"
                                                        type="number"
                                                        v-model="ammeterInfo.stst_longitude"
                                                        class="form-control"
                                                />
                                            </div>
                                            <label class="col-sm-2 control-label">纬度：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_latitude"
                                                        type="number"
                                                        v-model="ammeterInfo.stst_latitude"
                                                        class="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div id="station_map" style="height:300px;"></div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 control-label">塔高：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_height"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_height"
                                                        class="form-control"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="tab-3" class="tab-pane">
                                    <div class="panel-body">
                                        <div class="form-group">
                                            <label class="col-sm-2 control-label">运营商：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_comm"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_comm"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                            <label class="col-sm-2 control-label">分管运营商：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_subcomm"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_subcomm"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 control-label">行政分区：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_area"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_area"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                            <label class="col-sm-2 control-label">局方合同号：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_commcontractno"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_commcontractno"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 control-label">局方甲方合同号：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_commcontractpartya"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_commcontractpartya"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                            <label class="col-sm-2 control-label">局方合同年限：</label>
                                            <div class="col-sm-4">
                                                <input
                                                        name="stst_commcontractstar"
                                                        type="number"
                                                        v-model="ammeterInfo.stst_commcontractstar"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="tab-4" class="tab-pane">
                                    <div class="panel-body">
                                        <div class="form-group">
                                            <label class="col-sm-3 control-label">代维公司名称：</label>
                                            <div class="col-sm-3">
                                                <select
                                                        name="stst_proxymaintainid"
                                                        class="chosen-select"
                                                        v-model="ammeterInfo.stst_proxymaintainid"
                                                >
                                                    <option value>&nbsp;</option>
                                                    <option
                                                            v-for="(item,index) in proxymaintain"
                                                            :key="index"
                                                            :value="item.name"
                                                    >{{item.name}}
                                                    </option>
                                                </select>
                                            </div>
                                            <label class="col-sm-3 control-label">代谈公司名称：</label>
                                            <div class="col-sm-3">
                                                <select
                                                        name="stst_proxytalksid"
                                                        class="chosen-select"
                                                        style="width: 100px;"
                                                        v-model="ammeterInfo.stst_proxytalksid"
                                                        readonly
                                                >
                                                    <option value>&nbsp;</option>
                                                    <option
                                                            v-for="(item,index) in proxytalk"
                                                            :key="index"
                                                            :value="item.name"
                                                    >{{item.name}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="tab-5" class="tab-pane">
                                    <div class="panel-body">
                                        <div class="form-group">
                                            <label class="col-sm-3 control-label">产权单位：</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_owner"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_owner"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                            <label class="col-sm-3 control-label">业主合同甲方：</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_ownercontractpartya"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_ownercontractpartya"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-3 control-label">业主经理姓名:</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_ownerbossname"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_ownerbossname"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                            <label class="col-sm-3 control-label">业主经理电话:</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_ownerbossphone"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_ownerbossphone"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-3 control-label">业主会计姓名:</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_owneraccountingname"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_owneraccountingname"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                            <label class="col-sm-3 control-label">业主会计电话:</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_owneraccountingphone"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_owneraccountingphone"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-3 control-label">业主电工姓名:</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_ownerelectricianname"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_ownerelectricianname"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                            <label class="col-sm-3 control-label">业主电工电话:</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_ownerelectricianphone"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_ownerelectricianphone"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="tab-6" class="tab-pane">
                                    <div class="panel-body">
                                        <div class="form-group">
                                            <label class="col-sm-3 control-label">结费公司：</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_paymentcompany"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_paymentcompany"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                            <label class="col-sm-3 control-label">电源方式：</label>
                                            <div ngdong class="col-sm-3">
                                                <input
                                                        name="stst_acmode"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_acmode"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-3 control-label">是否预付电费：</label>
                                            <div class="col-sm-3 selected_remind_input">
                                                <!-- <input name="stst_prepaid" type="checkbox" v-model="ammeterInfo.stst_prepaid" class="js-switch" /> -->
                                                <input
                                                        name="stst_prepaid"
                                                        id="stst_prepaid"
                                                        v-model="ammeterInfo.stst_prepaid"
                                                        type="checkbox"
                                                        readonly
                                                />
                                                <label for="stst_prepaid">Check</label>
                                            </div>
                                            <label class="col-sm-3 control-label">共电编号：</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_unionno"
                                                        type="text"
                                                        v-model="ammeterInfo.stst_unionno"
                                                        class="form-control"
                                                        readonly
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-3 control-label">供电线路说明：</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_circuitdiagramtext"
                                                        type="text"
                                                        class="form-control"
                                                        v-model="ammeterInfo.stst_circuitdiagramtext"
                                                />
                                            </div>
                                            <label class="col-sm-3 control-label">供电线路图路径：</label>
                                            <div class="col-sm-3">
                                                <input
                                                        name="stst_circuitdiagrampath"
                                                        class="form-control"
                                                        v-model="ammeterInfo.stst_circuitdiagrampath"
                                                />
                                                <!--  type="file" -->
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-3 control-label">供电线路图：</label>
                                            <div class="col-sm-3">
                                                <img
                                                        style="width:200px;margin-bottom:6px;"
                                                        v-if="ammeterInfo.stst_circuitdiagrampath"
                                                        :src="ammeterInfo.circuitdiagrampath"
                                                />
                                                <span v-else>暂无图片</span>
                                                <input
                                                        type="file"
                                                        id="circuitdiagrampath"
                                                        placeholder="选择基站照片"
                                                        class="form-control file-pretty_station"
                                                        @change="changeImg('circuitdiagrampath')"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button
                            type="button"
                            data-dismiss="modal"
                            class="btn btn-primary"
                            @click="submitammeter"
                    >确定
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  var map
  var marker
  export default {
    data () {
      return {
        ammeterInfo: [], // 电表信息
        proxymaintain: [], // 代维公司
        proxytalk: [], // 代谈公司
        stationpicture: '', // 上传图片返回的图片路径
        circuitdiagrampath: '' //上传线路图传出的图片路径
      }
    },
    props: ['msgStationid'],
    mounted: function () {
      var self = this
      $('.chosen-select')
        .chosen({
          disable_search_threshold: 10,
          search_contains: true,
          width: '100%'
        })
        .change(function () {
          var type = $(this).prop('name')
          self.ammeterInfo[type] = $(this).val()
          console.log(self.ammeterInfo[type])
        })
      self.getcompaylist()
      $('.file-pretty_station').prettyFile()
    },
    methods: {
      //选择图片
      changeImg: function (eleid) {
        // 上传返回file_path;
        var self = this
        self.global.uploadfile(
          self,
          eleid,
          function (res) {
            console.log(res)
            if (res.status == 'success') {
              self[eleid] = res.file_path
              console.log(self.ammeterInfo)
            } else {
              alert('图片上传失败')
            }
          },
          function () {
            alert('图片上传失败')
          }
        )
      },
      getData: function () {
        var self = this
        $('.input-large').val('')
        // 获取基站详情
        self.global.axiosGet(self, 'station/' + self.msgStationid + '/', function (
          res
        ) {
          console.log('获取基站详情', res)
          res.stst_prepaid == null
            ? (res.stst_prepaid = false)
            : (res.stst_prepaid = true)
          res.stationpicture = self.global.ossHost + res.stst_stationpicture
          res.circuitdiagrampath =
            self.global.ossHost + res.stst_circuitdiagrampath
          self.ammeterInfo = res
          setTimeout(function () {
            $('.chosen-select').trigger('chosen:updated')
            // 初始化地图经纬度
            console.log(
              '经纬度',
              self.ammeterInfo.stst_longitude,
              self.ammeterInfo.stst_latitude
            )
            map = new AMap.Map('station_map', {
              resizeEnable: true,
              center: [
                self.ammeterInfo.stst_longitude,
                self.ammeterInfo.stst_latitude
              ],
              zoom: 13
            })
            marker = new AMap.Marker({
              position: map.getCenter(),
              offset: new AMap.Pixel(-13, -30),
              draggable: true
            })
            marker.setMap(map)
            marker.on('dragging', function () {
              self.ammeterInfo.stst_longitude = marker.getPosition().getLng()
              self.ammeterInfo.stst_latitude = marker.getPosition().getLat()
            })
          }, 500)
        })
      },
      // 获取所有的代谈和代维公司
      getcompaylist: function () {
        var self = this
        self.global.axiosGet(self, 'organizations/?search=代谈公司', function (
          res
        ) {
          console.log('代谈公司', res)
          self.proxytalk = res
          setTimeout(function () {
            $('.chosen-select').trigger('chosen:updated')
          }, 500)
        })
        self.global.axiosGet(self, 'organizations/?search=代维公司', function (
          res
        ) {
          console.log('代维公司', res)
          self.proxymaintain = res
          setTimeout(function () {
            $('.chosen-select').trigger('chosen:updated')
          }, 500)
        })
      },
      // 修改基站信息
      submitammeter: function () {
        var self = this
        var submitInfo = {}

        // stst_commname (string) – 基站名称
        submitInfo.stst_commname = self.ammeterInfo.stst_commname
        // stst_proxymaintainid (string) – 代维公司
        submitInfo.stst_proxymaintainid = self.ammeterInfo.stst_proxymaintainid
        // stst_longitude (string) – 位置经度
        submitInfo.stst_longitude = self.ammeterInfo.stst_longitude
        // stst_latitude (string) – 位置纬度
        submitInfo.stst_latitude = self.ammeterInfo.stst_latitude
        // stst_type (string) – 基站类型 [“楼站” | “塔站”]
        submitInfo.stst_type = self.ammeterInfo.stst_type
        // stst_height (string) – 塔高
        submitInfo.stst_height = self.ammeterInfo.stst_height
        // stst_address (string) – 地址
        submitInfo.stst_address = self.ammeterInfo.stst_address
        // stst_stationpicture (string) – 基站照片
        self.stationpicture == ''
          ? (submitInfo.stst_stationpicture = '')
          : (submitInfo.stst_stationpicture = self.stationpicture)
        // stst_circuitdiagramnode (string) – 供电线路图地图节点
        submitInfo.stst_circuitdiagramnode =
          self.ammeterInfo.stst_circuitdiagramnode
        // stst_circuitdiagrampath (string) – 供电线路图路径
        self.circuitdiagramnode == ""
        ? (submitInfo.stst_circuitdiagrampath = self.ammeterInfo.stst_circuitdiagrampath)
        : (submitInfo.stst_circuitdiagrampath = self.circuitdiagrampath)
        // stst_circuitdiagramtext (string) – 供电线路说明
        submitInfo.stst_circuitdiagramtext =
          self.ammeterInfo.stst_circuitdiagramtext
        // stst_remarks (string) – 备注
        console.log('修改基站信息', submitInfo)
        self.global.axiosPut(
          self,
          'station/' + self.msgStationid + '/',
          submitInfo,
          function (res) {
            console.log(res)
            alert('操作完成')
            $('#stationManager_atptable').bootstrapTable('refresh')
          },
          function (res) {
            console.log(res)
            alert('操作失败')
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/stationmanager/stationDetails.vue